module.exports = __webpack_public_path__ + "img/previous.0ea26a70.svg";